var map = {
	"./additionalInfoIcon.svg": 543,
	"./arrowLeftIcon.svg": 544,
	"./arrowMediumTop.svg": 545,
	"./arrowRightIcon.svg": 546,
	"./arrowRightIconSharp.svg": 547,
	"./arrowRightSmallIcon.svg": 548,
	"./arrowScalableIcon.svg": 549,
	"./arrowSelect2.svg": 550,
	"./arrowSelectIcon.svg": 551,
	"./benefit1.svg": 552,
	"./benefit2.svg": 553,
	"./benefit3.svg": 554,
	"./cardsIcon.svg": 555,
	"./checkCirсleIcon.svg": 556,
	"./circleInfoIcon.svg": 557,
	"./copyIcon copy.svg": 558,
	"./copyIcon.svg": 559,
	"./crossIcon.svg": 560,
	"./crossIcon2.svg": 561,
	"./crossIcon3.svg": 562,
	"./crossIconSmall.svg": 563,
	"./crossSmallIcon.svg": 564,
	"./defaultCategoryIcon.svg": 565,
	"./depNumberIcon.svg": 566,
	"./elfCentralIcon.svg": 567,
	"./equalitySign.svg": 568,
	"./errorIcon.svg": 454,
	"./eyeClosedIcon.svg": 569,
	"./eyeOpenIcon.svg": 570,
	"./favoritesIcon.svg": 571,
	"./favoritesLabelIcon.svg": 572,
	"./filterDivider.svg": 573,
	"./filterIcon.svg": 574,
	"./frequencyIcon.svg": 575,
	"./fsAmountIcon.svg": 576,
	"./fullScreenIcon.svg": 577,
	"./gameIcon.svg": 578,
	"./goldGiftIcon.svg": 579,
	"./hamburgerIcon.svg": 580,
	"./infoIcon.svg": 581,
	"./infoSymbol.svg": 582,
	"./levelBackground.svg": 583,
	"./levelBackgroundNew.svg": 584,
	"./linkIcon.svg": 585,
	"./lockIcon.svg": 586,
	"./lockSharpIcon.svg": 587,
	"./maxBonusAmountIcon.svg": 588,
	"./maxWinFsIcon.svg": 589,
	"./menuIcon.svg": 590,
	"./minDepIcon.svg": 591,
	"./noTournamentIcon.svg": 592,
	"./playIcon.svg": 593,
	"./polygon.svg": 594,
	"./preloaderDotsAnimation.svg": 595,
	"./preloaderSpinnerAnimation.svg": 596,
	"./presentIcon.svg": 597,
	"./promoIcon.svg": 598,
	"./recentIcon.svg": 599,
	"./search2Icon.svg": 600,
	"./search3Icon.svg": 601,
	"./sharpTickIcon copy.svg": 602,
	"./sharpTickIcon.svg": 603,
	"./smallInfoSymbol.svg": 604,
	"./smoothArrowIcon.svg": 605,
	"./successIcon.svg": 606,
	"./supportIcon.svg": 607,
	"./tag1Icon.svg": 608,
	"./tag2Icon.svg": 609,
	"./tag3Icon.svg": 610,
	"./tag4Icon.svg": 611,
	"./tickIcon.svg": 612,
	"./unverified.svg": 613,
	"./verified.svg": 614,
	"./wagerIcon.svg": 615,
	"./wagerTimeIcon.svg": 616,
	"./warningIcon.svg": 617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 542;